/* global axios */
import ApiClient from './ApiClient';

class SearchConsoleAPI extends ApiClient {
  constructor() {
    super('search_console/reports', { accountScoped: true });
  }

  sites(connectionId) {
    return axios.get(`${this.url}/sites`, {
      params: { connection_id: connectionId },
    });
  }

  // range { since, until } em YYYY-MM-DD (periodo da barra de contexto).
  // Sem connectionId/siteUrl, o backend AGREGA todos os sites marcados na
  // config. Devolve { data, accounts }.
  report(connectionId, siteUrl, range = {}) {
    const params = { since: range.since, until: range.until };
    if (connectionId) params.connection_id = connectionId;
    if (siteUrl) params.site_url = siteUrl;
    return axios.get(this.url, { params });
  }
}

export default new SearchConsoleAPI();
